import { KpisPage } from '@/features/kpis/pages/KpisPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/kpis')({
  component: KpisPage,
});
